// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"90c2dc14","703":"7cb5d3c1","787":"8043e316"}[chunkId] + ".chunk.js";
};